"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6581],{

/***/ 50550:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(33070);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);
/* harmony import */ var _style_device__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74575);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-header {\n    border-bottom: 0;\n    padding: 0;\n  }\n\n  .ant-modal-body {\n    padding: 0;\n  }\n\n  .ant-modal-footer {\n    border-top: 0;\n    padding: 0;\n    text-align: unset;\n  }\n\n  .ant-modal-footer button + button {\n    margin: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-content {\n    background: unset;\n    box-shadow: unset;\n  }\n\n  .ant-modal-close {\n    top: 20px;\n    right: 30px;\n    font-size: 14px;\n    font-weight: bold;\n  }\n\n  .ant-modal-body {\n    padding: 0;\n  }\n\n  .ant-modal-header {\n    background: unset;\n    border: 0;\n    padding: 0;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: unset !important;\n  height: 100vh;\n  top: unset;\n  background-color: ",
        ";\n  max-width: unset;\n  margin: unset;\n\n  .ant-modal-header {\n    border: unset;\n    padding: 40px 50px 30px;\n  }\n\n  .ant-modal-close {\n    top: 3%;\n  }\n\n  .ant-modal-content {\n    box-shadow: unset;\n    margin: auto;\n    width: 100%;\n    height: 100%;\n  }\n\n  .ant-modal-body {\n    padding: 0;\n    height: 90%;\n    overflow-y: scroll;\n  }\n\n  @media ",
        " {\n    .ant-modal-content {\n      width: 660px;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var basicModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject());
var transparentModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject1());
var fullscreenModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject2(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light, _style_device__WEBPACK_IMPORTED_MODULE_2__/* ["default"].tablet */ .Z.tablet);
var modalTypes = {
    basic: basicModal,
    transparent: transparentModal,
    fullscreen: fullscreenModal
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs(function(props) {
    return {
        footer: props.footer || false,
        type: props.type || "basic"
    };
}).withConfig({
    componentId: "sc-f78b26fb-0"
})(_templateObject3(), function(param) {
    var type = param.type;
    return modalTypes[type];
}));


/***/ }),

/***/ 89999:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ HumbergerButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71577);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22147);
/* harmony import */ var _hoc_withSpacing__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97214);
/* eslint-disable react/jsx-props-no-spreading */ 



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background: ",
        ";\n    border-color: ",
        ";\n    color: ",
        ";\n    :hover,\n    :focus,\n    :active {\n      background: ",
        ";\n      border-color: ",
        ";\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background: ",
        ";\n    border-color: ",
        ";\n    color: ",
        ";\n    :hover,\n    :focus,\n    :active {\n      background: ",
        ";\n      border-color: ",
        ";\n    }\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background: ",
        ";\n    border-color: ",
        ";\n    color: ",
        ";\n    :hover,\n    :focus,\n    :active {\n      color: ",
        ";\n      background: ",
        ";\n      border-color: ",
        ";\n    }\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background: ",
        ";\n    border-color: ",
        ";\n    :hover,\n    :focus,\n    :active {\n      background: ",
        ";\n      border-color: ",
        ";\n    }\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background: ",
        ";\n    border-color: ",
        ";\n    :hover,\n    :focus,\n    :active {\n      color: ",
        ";\n      background: ",
        ";\n      border-color: ",
        ";\n    }\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        ,\n        :hover {\n          background: ",
        ";\n          color: ",
        ";\n        }\n      "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background: ",
        ";\n    border: none;\n    border-bottom: 1px solid ",
        ";\n    :hover,\n    :focus {\n      border-color: ",
        ";\n      color: ",
        ";\n    }\n\n    ",
        ";\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    border-radius: ",
        ";\n    height: ",
        ";\n    margin: ",
        ";\n    padding: ",
        ";\n    \n    ::after{\n      content: unset;\n    }\n    \n    ",
        ";\n    border : ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      background: ",
        ";\n      border-left: 1px solid ",
        ';\n      position: relative;\n      ::after {\n        content: "";\n        position: absolute;\n        bottom: 0;\n        width: 100%;\n        height: 2px;\n        background: ',
        ";\n      }\n      span:nth-child(1) {\n        transform: rotate(45deg);\n        position: relative;\n        top: 5px;\n      }\n      span:nth-child(2) {\n        display: none;\n      }\n      span:nth-child(3) {\n        transform: rotate(-45deg);\n        position: relative;\n        bottom: 0;\n      }\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n  width: 40px;\n  height: 40px;\n  padding: 10px;\n  \n  span {\n    display: block;\n    height: 1px;\n    width: 16px;\n    background: ",
        ";\n    margin: 4px auto 0;\n    transition : 0.3s;\n  }\n  \n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}






var buttonType = {
    sunsetOrange: (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].sunsetOrange */ .Z.sunsetOrange, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].sunsetOrange */ .Z.sunsetOrange, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].sunsetOrange */ .Z.sunsetOrange, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].sunsetOrange */ .Z.sunsetOrange),
    highempahis: (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].highempahis */ .Z.highempahis, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].highempahis */ .Z.highempahis, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].highempahis */ .Z.highempahis, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].highempahis */ .Z.highempahis),
    defaultHoverable: (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject2(), _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].primary */ .Z.primary),
    default: (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject3(), _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].gainsboro */ .Z.gainsboro),
    primary: (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject4(), _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].primary */ .Z.primary),
    widget: (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject6(), _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].highempahis */ .Z.highempahis, function(param) {
        var active = param.active;
        return active && (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject5(), _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].aliceBlue */ .Z.aliceBlue, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].primary */ .Z.primary);
    })
};
var ButtonCustom = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.memo((0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    shouldForwardProp: function(prop) {
        return ![
            "round",
            "active",
            "borderLess"
        ].includes(prop);
    }
}).attrs(function(props) {
    return {
        height: props.height || "auto",
        type: props.type || "default",
        round: props.round,
        active: props.active,
        borderLess: props.borderLess,
        margin: props.margin || "0 !important",
        padding: props.padding || "4px 15px"
    };
}).withConfig({
    componentId: "sc-6d94ba47-0"
})(_templateObject7(), function(param) {
    var round = param.round;
    return round ? "2px" : "0px";
}, function(param) {
    var height = param.height;
    return height;
}, function(param) {
    var margin = param.margin;
    return margin;
}, function(param) {
    var padding = param.padding;
    return padding;
}, function(param) {
    var type = param.type;
    return buttonType[type];
}, function(param) {
    var borderLess = param.borderLess;
    return borderLess && "none";
}));
var HumbergerButtonComp = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    shouldForwardProp: function(props) {
        return ![
            "active"
        ].includes(props);
    }
}).attrs(function(props) {
    return {
        active: props.active
    };
}).withConfig({
    componentId: "sc-6d94ba47-1"
})(_templateObject9(), _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].dimgray */ .Z.dimgray, function(param) {
    var active = param.active;
    return active && (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject8(), _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].light */ .Z.light);
});
var HumbergerButton = function(_param) /*#__PURE__*/ {
    var className = _param.className, otherProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(HumbergerButtonComp, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
        className: className
    }, otherProps), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {})
        ]
    }));
};

/* harmony default export */ __webpack_exports__["Z"] = ((0,_hoc_withSpacing__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(ButtonCustom));


/***/ }),

/***/ 61166:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79931);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        .ant-table-thead > tr > th,\n        .ant-table-tbody > tr > td {\n          border: none;\n        }\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    .ant-table-cell {\n      padding: 0 !important;\n    }\n    .ant-table-thead > tr > th,\n    .ant-table-tbody > tr > td {\n      border-bottom: 1px solid ",
        ";\n    }\n\n    .ant-table-tbody > tr {\n      position: relative;\n    }\n    .ant-table-tbody > tr:hover > td {\n      background: ",
        ";\n    }\n    .ant-pagination-item-active{\n      border-color : ",
        ";\n    }\n    .ant-pagination-item-active a,\n    .ant-pagination-item:focus a, \n    .ant-pagination-item:hover a{\n      color : ",
        "\n    }\n\n    ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



/* harmony default export */ __webpack_exports__["Z"] = ((0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    shouldForwardProp: function(props) {
        return ![
            "borderless"
        ].includes(props);
    }
}).attrs(function(props) {
    return {
        borderless: props.borderless
    };
}).withConfig({
    componentId: "sc-43a24ac8-0"
})(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].aliceBlue */ .Z.aliceBlue, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].aliceBlue */ .Z.aliceBlue, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary, function(param) {
    var borderless = param.borderless;
    return borderless && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject());
}));


/***/ }),

/***/ 8150:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56266);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/* harmony default export */ __webpack_exports__["Z"] = ((0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-71cb950b-0"
})(_templateObject()));


/***/ }),

/***/ 36296:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N8": function() { return /* binding */ TYPE_CUSTOM_PRESET; },
/* harmony export */   "QR": function() { return /* binding */ DEFAULT_TYPE_PRESET; },
/* harmony export */   "qe": function() { return /* binding */ INITIAL_PAGE; },
/* harmony export */   "rz": function() { return /* binding */ KENNETH_FISHER_PRICE_TO_SALES_ID; }
/* harmony export */ });
var INITIAL_PAGE = 1;
var KENNETH_FISHER_PRICE_TO_SALES_ID = 2;
var DEFAULT_TYPE_PRESET = "TEMPLATE_TYPE_GURU";
var TYPE_CUSTOM_PRESET = "TEMPLATE_TYPE_CUSTOM";


/***/ }),

/***/ 9139:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sz": function() { return /* binding */ effects; },
/* harmony export */   "wl": function() { return /* binding */ selectors; }
/* harmony export */ });
/* unused harmony export reducers */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61876);
/* harmony import */ var lib_api_valuation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17065);
/* harmony import */ var lib_api_screener__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70735);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36296);




// Related Modules



// Actions
var CONTEXT = "@side-widget/valuation";
var actionType = {
    // valuation
    GET_VALUATION_TEMPLATE: "".concat(CONTEXT, "/GET_VALUATION_TEMPLATE"),
    GET_VALUATION_METRICS: "".concat(CONTEXT, "/GET_VALUATION_METRICS"),
    POST_DELETE_VALUATION_TEMPLATE: "".concat(CONTEXT, "/POST_DELETE_VALUATION_TEMPLATE"),
    POST_VALUATION_RESULT: "".concat(CONTEXT, "/POST_VALUATION_RESULT"),
    POST_VALUATION_TEMPLATE_SAVE: "".concat(CONTEXT, "/POST_VALUATION_TEMPLATE_SAVE"),
    POST_VALUATION_TEMPLATE_ADD: "".concat(CONTEXT, "/POST_VALUATION_TEMPLATE_ADD"),
    GET_VALUATION_TEMPLATE_LOAD: "".concat(CONTEXT, "/GET_VALUATION_TEMPLATE_LOAD"),
    GET_VALUATION_METRICS_DEFAULT: "".concat(CONTEXT, "/GET_VALUATION_METRICS_DEFAULT"),
    // screener
    GET_SCREENER_CUSTOM: "".concat(CONTEXT, "/GET_SCREENER_CUSTOM"),
    GET_SCREENER_METRICS: "".concat(CONTEXT, "/GET_SCREENER_METRICS"),
    GET_LOAD_PRESET_SCREENER: "".concat(CONTEXT, "/GET_LOAD_PRESET_SCREENER"),
    POST_SCREENER_LIST_RESULT: "".concat(CONTEXT, "/POST_SCREENER_LIST_RESULT")
};
// initial state
var initialState = {
    // valuation
    getValuationTemplate: {
        data: [],
        isLoading: true,
        error: null
    },
    getValuationMetrics: {
        data: {},
        isLoading: true,
        error: null
    },
    getValuationTemplateLoad: {
        data: {},
        isLoading: false,
        error: null
    },
    getValuationMetricsDefault: {
        data: [],
        isLoading: true,
        error: null
    },
    postDeleteValuationTemplate: {
        data: [],
        isLoading: false,
        error: null,
        isSubmitted: false
    },
    postValuationResult: {
        data: [],
        isLoading: false,
        error: null,
        isSubmitted: false
    },
    postValuationTemplateSave: {
        data: [],
        isLoading: false,
        error: null,
        isSubmitted: false
    },
    postValuationTemplateAdd: {
        data: {},
        isLoading: false,
        error: null,
        isSubmitted: false
    },
    // screener
    getScreenerCustom: {
        data: [],
        isLoading: true,
        error: null
    },
    getScreenerMetrics: {
        data: [],
        isLoading: true,
        error: null
    },
    getLoadPresetScreener: {
        data: {},
        isLoading: true,
        error: null
    },
    postScreenerListResult: {
        data: [],
        isLoading: false,
        error: null,
        isSubmitted: false
    },
    // TODO: Remove this lines after layout feature has been implemented
    currentScreenerData: {
        page: _constants__WEBPACK_IMPORTED_MODULE_3__/* .INITIAL_PAGE */ .qe,
        presetId: _constants__WEBPACK_IMPORTED_MODULE_3__/* .KENNETH_FISHER_PRICE_TO_SALES_ID */ .rz,
        isDataLoaded: false,
        shouldUpdate: false,
        type: ""
    }
};
// Selectors
var valuationState = function(state) {
    return state.mainLayout.valuation;
};
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createSelector */ .P1)(valuationState, function(state) {
    return {
        // valuation
        getValuationTemplate: state.getValuationTemplate,
        getValuationMetrics: state.getValuationMetrics,
        getValuationTemplateLoad: state.getValuationTemplateLoad,
        getValuationMetricsDefault: state.getValuationMetricsDefault,
        postDeleteValuationTemplate: state.postDeleteValuationTemplate,
        postValuationResult: state.postValuationResult,
        postValuationTemplateSave: state.postValuationTemplateSave,
        postValuationTemplateAdd: state.postValuationTemplateAdd,
        // screener
        getScreenerCustom: state.getScreenerCustom,
        getScreenerMetrics: state.getScreenerMetrics,
        getLoadPresetScreener: state.getLoadPresetScreener,
        postScreenerListResult: state.getLoadPresetScreener,
        // TODO: Remove this lines after layout feature has been implemented
        currentScreenerData: state.currentScreenerData
    };
}, function(state) {
    return state;
});
// Reducer
var reducers = {
    // TODO: Remove this lines after layout feature has been implemented
    setCurrentScreenerData: function(state, action) {
        state.currentScreenerData = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, state.currentScreenerData, action.payload);
    }
};
// effects
var effects = {
    // getValuationTemplate
    getValuationTemplate: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.GET_VALUATION_TEMPLATE, (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var response, _data, data, _$error, message;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return lib_api_valuation__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getValuationTemplate */ .Z.getValuationTemplate();
                case 3:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Error when get list valuation template");
                case 6:
                    _data = response.data, data = _data.data, _$error = _data.error, message = _data.message;
                    if (!_$error) {
                        _ctx.next = 9;
                        break;
                    }
                    throw new Error(_$error);
                case 9:
                    return _ctx.abrupt("return", {
                        data: data,
                        message: message
                    });
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                12
            ]
        ]);
    }))),
    // getValuationMetrics
    getValuationMetrics: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.GET_VALUATION_METRICS, (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var response, _data, data, _$error, message;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return lib_api_valuation__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getValuationMetrics */ .Z.getValuationMetrics();
                case 3:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Error when get list valuation metrics");
                case 6:
                    _data = response.data, data = _data.data, _$error = _data.error, message = _data.message;
                    if (!_$error) {
                        _ctx.next = 9;
                        break;
                    }
                    throw new Error(_$error);
                case 9:
                    return _ctx.abrupt("return", {
                        data: data,
                        message: message
                    });
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                12
            ]
        ]);
    }))),
    // getValuationTemplateLoad
    getValuationTemplateLoad: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.GET_VALUATION_TEMPLATE_LOAD, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(templateId) {
            var response, _data, data, _$error, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_valuation__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getValuationTemplateLoad */ .Z.getValuationTemplateLoad(templateId);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Error when get detail valuation template");
                    case 6:
                        _data = response.data, data = _data.data, _$error = _data.error, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        throw new Error(_$error);
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(templateId) {
            return _ref.apply(this, arguments);
        };
    }()),
    // getValuationMetricsDefault
    getValuationMetricsDefault: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.GET_VALUATION_METRICS_DEFAULT, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(queryString) {
            var response, _data, data, _$error, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_valuation__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getValuationMetricsDefault */ .Z.getValuationMetricsDefault(queryString);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Error when get valuation metrics default");
                    case 6:
                        _data = response.data, data = _data.data, _$error = _data.error, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        throw new Error(_$error);
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(queryString) {
            return _ref.apply(this, arguments);
        };
    }()),
    // postValuationResult
    postValuationResult: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.POST_VALUATION_RESULT, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(requestBody) {
            var response, _data, data, _$error, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_valuation__WEBPACK_IMPORTED_MODULE_1__/* ["default"].postValuationResult */ .Z.postValuationResult(requestBody);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Error when post valuation result");
                    case 6:
                        _data = response.data, data = _data.data, _$error = _data.error, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        throw new Error(_$error);
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(requestBody) {
            return _ref.apply(this, arguments);
        };
    }()),
    // postValuationTemplateSave
    postValuationTemplateSave: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.POST_VALUATION_TEMPLATE_SAVE, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var templateId, requestBody, response, _data, data, _$error, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        templateId = param.templateId, requestBody = param.requestBody;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return lib_api_valuation__WEBPACK_IMPORTED_MODULE_1__/* ["default"].postValuationTemplateSave */ .Z.postValuationTemplateSave(templateId, requestBody);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Error when save valuation template");
                    case 7:
                        _data = response.data, data = _data.data, _$error = _data.error, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        throw new Error(_$error);
                    case 10:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    13
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    // postValuationTemplateAdd
    postValuationTemplateAdd: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.POST_VALUATION_TEMPLATE_ADD, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(requestBody) {
            var response, _data, data, _$error, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_valuation__WEBPACK_IMPORTED_MODULE_1__/* ["default"].postValuationTemplateAdd */ .Z.postValuationTemplateAdd(requestBody);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Error when add valuation template");
                    case 6:
                        _data = response.data, data = _data.data, _$error = _data.error, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        throw new Error(_$error);
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(requestBody) {
            return _ref.apply(this, arguments);
        };
    }()),
    // screener
    // getScreenerCustom
    getScreenerCustom: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.GET_SCREENER_CUSTOM, (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var response, _data, data, _$error, message;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return lib_api_screener__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getScreenerCustom */ .Z.getScreenerCustom();
                case 3:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Error when get list screener custom");
                case 6:
                    _data = response.data, data = _data.data, _$error = _data.error, message = _data.message;
                    if (!_$error) {
                        _ctx.next = 9;
                        break;
                    }
                    throw new Error(_$error);
                case 9:
                    return _ctx.abrupt("return", {
                        data: data,
                        message: message
                    });
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                12
            ]
        ]);
    }))),
    // getScreenerMetrics
    getScreenerMetrics: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.GET_SCREENER_METRICS, (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var response, _data, data, _$error, message;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return lib_api_screener__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getScreenerMetrics */ .Z.getScreenerMetrics();
                case 3:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Error when get list screener metrics");
                case 6:
                    _data = response.data, data = _data.data, _$error = _data.error, message = _data.message;
                    if (!_$error) {
                        _ctx.next = 9;
                        break;
                    }
                    throw new Error(_$error);
                case 9:
                    return _ctx.abrupt("return", {
                        data: data,
                        message: message
                    });
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                12
            ]
        ]);
    }))),
    // getLoadPresetScreener
    getLoadPresetScreener: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.GET_LOAD_PRESET_SCREENER, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var presetId, type, response, _data, data, _$error, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        presetId = param.presetId, type = param.type;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return lib_api_screener__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getLoadPresetScreener */ .Z.getLoadPresetScreener(presetId, type);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Error when get load preset screener");
                    case 7:
                        _data = response.data, data = _data.data, _$error = _data.error, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        throw new Error(_$error);
                    case 10:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    13
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    // postDeleteValuationTemplate
    postDeleteValuationTemplate: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.POST_DELETE_VALUATION_TEMPLATE, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(valuationId) {
            var response, _data, data, _$error, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_valuation__WEBPACK_IMPORTED_MODULE_1__/* ["default"].postDeleteValuationTemplate */ .Z.postDeleteValuationTemplate(valuationId);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Error when delete valuation template");
                    case 6:
                        _data = response.data, data = _data.data, _$error = _data.error, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        throw new Error(_$error);
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(valuationId) {
            return _ref.apply(this, arguments);
        };
    }()),
    // postScreenerListResult
    postScreenerListResult: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.POST_SCREENER_LIST_RESULT, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(requestBody) {
            var response, _data, data, _$error, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_screener__WEBPACK_IMPORTED_MODULE_2__/* ["default"].postScreenerListResult */ .Z.postScreenerListResult(requestBody);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Error when post screener list result");
                    case 6:
                        _data = response.data, data = _data.data, _$error = _data.error, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        throw new Error(_$error);
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(requestBody) {
            return _ref.apply(this, arguments);
        };
    }())
};
// Extra / Async Reducer
var extraReducers = function(builder) {
    // getValuationTemplate
    builder// Extra reducers for fetch suggestions
    .addCase(effects.getValuationTemplate.pending, function(state) {
        state.getValuationTemplate.error = null;
        state.getValuationTemplate.isLoading = true;
    }).addCase(effects.getValuationTemplate.fulfilled, function(state, action) {
        state.getValuationTemplate.data = action.payload.data;
        state.getValuationTemplate.error = null;
        state.getValuationTemplate.isLoading = false;
        state.getValuationTemplate.message = action.payload.message;
    }).addCase(effects.getValuationTemplate.rejected, function(state, action) {
        state.getValuationTemplate.error = action.error;
        state.getValuationTemplate.isLoading = false;
    }).addCase(effects.getValuationMetrics.pending, function(state) {
        state.getValuationMetrics.error = null;
        state.getValuationMetrics.isLoading = true;
    }).addCase(effects.getValuationMetrics.fulfilled, function(state, action) {
        state.getValuationMetrics.data = action.payload.data;
        state.getValuationMetrics.error = null;
        state.getValuationMetrics.isLoading = false;
        state.getValuationMetrics.message = action.payload.message;
    }).addCase(effects.getValuationMetrics.rejected, function(state, action) {
        state.getValuationMetrics.error = action.error;
        state.getValuationMetrics.isLoading = false;
    }).addCase(effects.getValuationTemplateLoad.pending, function(state) {
        state.getValuationTemplateLoad.error = null;
        state.getValuationTemplateLoad.isLoading = true;
    }).addCase(effects.getValuationTemplateLoad.fulfilled, function(state, action) {
        state.getValuationTemplateLoad.data = action.payload.data;
        state.getValuationTemplateLoad.error = null;
        state.getValuationTemplateLoad.isLoading = false;
        state.getValuationTemplateLoad.message = action.payload.message;
    }).addCase(effects.getValuationTemplateLoad.rejected, function(state, action) {
        state.getValuationTemplateLoad.error = action.error;
        state.getValuationTemplateLoad.isLoading = false;
    }).addCase(effects.getValuationMetricsDefault.pending, function(state) {
        state.getValuationMetricsDefault.error = null;
        state.getValuationMetricsDefault.isLoading = true;
    }).addCase(effects.getValuationMetricsDefault.fulfilled, function(state, action) {
        state.getValuationMetricsDefault.data = action.payload.data;
        state.getValuationMetricsDefault.error = null;
        state.getValuationMetricsDefault.isLoading = false;
        state.getValuationMetricsDefault.message = action.payload.message;
    }).addCase(effects.getValuationMetricsDefault.rejected, function(state, action) {
        state.getValuationMetricsDefault.error = action.error;
        state.getValuationMetricsDefault.isLoading = false;
    }).addCase(effects.getScreenerCustom.pending, function(state) {
        state.getScreenerCustom.error = null;
        state.getScreenerCustom.isLoading = true;
    }).addCase(effects.getScreenerCustom.fulfilled, function(state, action) {
        state.getScreenerCustom.data = action.payload.data;
        state.getScreenerCustom.error = null;
        state.getScreenerCustom.isLoading = false;
        state.getScreenerCustom.message = action.payload.message;
    }).addCase(effects.getScreenerCustom.rejected, function(state, action) {
        state.getScreenerCustom.error = action.error;
        state.getScreenerCustom.isLoading = false;
    }).addCase(effects.getScreenerMetrics.pending, function(state) {
        state.getScreenerMetrics.error = null;
        state.getScreenerMetrics.isLoading = true;
    }).addCase(effects.getScreenerMetrics.fulfilled, function(state, action) {
        state.getScreenerMetrics.data = action.payload.data;
        state.getScreenerMetrics.error = null;
        state.getScreenerMetrics.isLoading = false;
        state.getScreenerMetrics.message = action.payload.message;
    }).addCase(effects.getScreenerMetrics.rejected, function(state, action) {
        state.getScreenerMetrics.error = action.error;
        state.getScreenerMetrics.isLoading = false;
    }).addCase(effects.getLoadPresetScreener.pending, function(state) {
        state.getLoadPresetScreener.error = null;
        state.getLoadPresetScreener.isLoading = true;
    }).addCase(effects.getLoadPresetScreener.fulfilled, function(state, action) {
        state.getLoadPresetScreener.data = action.payload.data;
        state.getLoadPresetScreener.error = null;
        state.getLoadPresetScreener.isLoading = false;
        state.getLoadPresetScreener.message = action.payload.message;
        state.currentScreenerData.isDataLoaded = true;
    }).addCase(effects.getLoadPresetScreener.rejected, function(state, action) {
        state.getLoadPresetScreener.error = action.error;
        state.getLoadPresetScreener.isLoading = false;
    }).addCase(effects.postDeleteValuationTemplate.pending, function(state) {
        state.postDeleteValuationTemplate.error = null;
        state.postDeleteValuationTemplate.isLoading = true;
        state.postDeleteValuationTemplate.isSubmitted = false;
    }).addCase(effects.postDeleteValuationTemplate.fulfilled, function(state, action) {
        state.postDeleteValuationTemplate.data = action.payload.data;
        state.postDeleteValuationTemplate.error = null;
        state.postDeleteValuationTemplate.isLoading = false;
        state.postDeleteValuationTemplate.message = action.payload.message;
        state.postDeleteValuationTemplate.isSubmitted = true;
    }).addCase(effects.postDeleteValuationTemplate.rejected, function(state, action) {
        state.postDeleteValuationTemplate.error = action.error;
        state.postDeleteValuationTemplate.isLoading = false;
        state.postDeleteValuationTemplate.isSubmitted = false;
    }).addCase(effects.postScreenerListResult.pending, function(state) {
        state.postScreenerListResult.error = null;
        state.postScreenerListResult.isLoading = true;
    }).addCase(effects.postScreenerListResult.fulfilled, function(state, action) {
        state.postScreenerListResult.data = action.payload.data;
        state.getLoadPresetScreener.data = action.payload.data;
        state.postScreenerListResult.error = null;
        state.postScreenerListResult.isLoading = false;
        state.postScreenerListResult.message = action.payload.message;
    }).addCase(effects.postScreenerListResult.rejected, function(state, action) {
        state.postScreenerListResult.error = action.error;
        state.postScreenerListResult.isLoading = false;
    }).addCase(effects.postValuationResult.pending, function(state) {
        state.postValuationResult.error = null;
        state.postValuationResult.isLoading = true;
        state.postValuationResult.isSubmitted = false;
    }).addCase(effects.postValuationResult.fulfilled, function(state, action) {
        state.postValuationResult.data = action.payload.data;
        state.postValuationResult.error = null;
        state.postValuationResult.isLoading = false;
        state.postValuationResult.message = action.payload.message;
        state.postValuationResult.isSubmitted = true;
    }).addCase(effects.postValuationResult.rejected, function(state, action) {
        state.postValuationResult.error = action.error;
        state.postValuationResult.isLoading = false;
        state.postValuationResult.isSubmitted = false;
    }).addCase(effects.postValuationTemplateSave.pending, function(state) {
        state.postValuationTemplateSave.error = null;
        state.postValuationTemplateSave.isLoading = true;
        state.postValuationTemplateSave.isSubmitted = false;
    }).addCase(effects.postValuationTemplateSave.fulfilled, function(state, action) {
        state.postValuationTemplateSave.data = action.payload.data;
        state.postValuationTemplateSave.error = null;
        state.postValuationTemplateSave.isLoading = false;
        state.postValuationTemplateSave.message = action.payload.message;
        state.postValuationTemplateSave.isSubmitted = true;
    }).addCase(effects.postValuationTemplateSave.rejected, function(state, action) {
        state.postValuationTemplateSave.error = action.error;
        state.postValuationTemplateSave.isLoading = false;
        state.postValuationTemplateSave.isSubmitted = false;
    }).addCase(effects.postValuationTemplateAdd.pending, function(state) {
        state.postValuationTemplateAdd.error = null;
        state.postValuationTemplateAdd.isLoading = true;
        state.postValuationTemplateAdd.isSubmitted = false;
    }).addCase(effects.postValuationTemplateAdd.fulfilled, function(state, action) {
        state.postValuationTemplateAdd.data = action.payload.data;
        state.postValuationTemplateAdd.error = null;
        state.postValuationTemplateAdd.isLoading = false;
        state.postValuationTemplateAdd.message = action.payload.message;
        state.postValuationTemplateAdd.isSubmitted = true;
    }).addCase(effects.postValuationTemplateAdd.rejected, function(state, action) {
        state.postValuationTemplateAdd.error = action.error;
        state.postValuationTemplateAdd.isLoading = false;
        state.postValuationTemplateAdd.isSubmitted = false;
    });
};
// Slice
var valuationSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createSlice */ .oM)({
    name: "valuation",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (valuationSlice);


/***/ }),

/***/ 69908:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ MainLayout_SideWidget; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/@deprecated-ui/widget/Tooltip.js
var Tooltip = __webpack_require__(8150);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(2497);
// EXTERNAL MODULE: ./src/utils/crisp.js
var crisp = __webpack_require__(65458);
// EXTERNAL MODULE: ./src/lib/entities/profile.js + 2 modules
var profile = __webpack_require__(333);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/zustand/esm/shallow.js
var shallow = __webpack_require__(60374);
// EXTERNAL MODULE: ./src/features/paywall/store/index.ts + 1 modules
var store = __webpack_require__(92182);
// EXTERNAL MODULE: ./src/features/paywall/types.ts
var types = __webpack_require__(5072);
// EXTERNAL MODULE: ./src/features/paywall/constants.ts
var constants = __webpack_require__(11298);
;// CONCATENATED MODULE: ./src/features/paywall/store/useWidget.ts





function useWidget(activeTab) {
    var ref = (0,react.useState)(false), isAddonPro = ref[0], setIsAddonPro = ref[1];
    var ref1 = (0,store/* default */.Z)(function(state) {
        return {
            isPro: state.widget.isPro,
            data: state.widget.data,
            getStatus: state.getStatus,
            addCounter: state.addCounter
        };
    }, shallow/* default */.Z), isPro = ref1.isPro, data = ref1.data, getStatus = ref1.getStatus, addCounter = ref1.addCounter;
    (0,react.useEffect)(function() {
        if (!(data === null || data === void 0 ? void 0 : data.features) || !activeTab) return;
        if (activeTab.toUpperCase() === constants/* AddOnWidget */.t9) {
            var addOnData = data.features.find(function(item) {
                return item.feature === constants/* PaywallFeatureEnum.SCREENER */.qU.SCREENER;
            });
            setIsAddonPro((addOnData === null || addOnData === void 0 ? void 0 : addOnData.is_eligible) || false);
        }
    }, [
        data === null || data === void 0 ? void 0 : data.features
    ]);
    var widgetGetStatus = function(key) {
        var KEY = key.toUpperCase();
        var feature = constants/* PaywallFeatureEnum */.qU[KEY];
        if (!feature) return;
        if (KEY === constants/* AddOnWidget */.t9) {
            var features = [
                constants/* PaywallFeatureEnum.VALUATION */.qU.VALUATION,
                constants/* PaywallFeatureEnum.SCREENER */.qU.SCREENER
            ];
            getStatus({
                key: types/* SectionEnum.widget */.P.widget,
                feature: features
            });
            return;
        }
        getStatus({
            key: types/* SectionEnum.widget */.P.widget,
            feature: feature
        });
    };
    // post paywall counter
    var widgetAddCounter = function(key) {
        var KEY = key.toUpperCase();
        var feature = constants/* PaywallFeatureEnum */.qU[KEY];
        if (!feature) return;
        addCounter({
            feature: feature
        });
        if (KEY === constants/* AddOnWidget */.t9) {
            addCounter({
                feature: constants/* PaywallFeatureEnum.SCREENER */.qU.SCREENER
            });
        }
    };
    (0,react.useEffect)(function() {
        if (!activeTab) return;
        widgetGetStatus(activeTab);
    }, [
        activeTab
    ]);
    return {
        isPro: isPro,
        isAddonPro: isAddonPro,
        addCounter: function(key) {
            return widgetAddCounter(key);
        }
    };
};

// EXTERNAL MODULE: ./src/global/WebSocket/slice.ts
var slice = __webpack_require__(23985);
// EXTERNAL MODULE: ./src/global/Securities/stores/useSearchCompanyModalStore.ts
var useSearchCompanyModalStore = __webpack_require__(5612);
// EXTERNAL MODULE: ./src/global/ErrorHandlers/If.js
var If = __webpack_require__(29658);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
;// CONCATENATED MODULE: ./src/assets/customIcon/sidewidget-icon/IconWatchlist.tsx


function IconWatchlist() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 26,
        height: 26,
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.5,
            d: "M13.4658 2.68632L16.3339 8.52652L22.7769 9.4514C23.2029 9.51375 23.3692 10.0333 23.0678 10.3347L18.4019 14.8759L19.5138 21.2877C19.5866 21.7137 19.1397 22.0359 18.7552 21.8384L12.9982 18.804L7.24109 21.8384C6.85659 22.0359 6.40974 21.7137 6.48249 21.2877L7.59441 14.8759L2.92848 10.3347C2.61673 10.0333 2.79339 9.51375 3.21946 9.4514L9.66238 8.52652L12.5305 2.68632C12.7176 2.30182 13.2683 2.30182 13.4658 2.68632Z"
        })
    });
};

;// CONCATENATED MODULE: ./src/assets/customIcon/sidewidget-icon/IconRunningTrade.tsx


function IconRunningTrade() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 26,
        height: 26,
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 1.5,
                d: "M12.751 2.568h1.901M13.71 10.156v4.258l2.845 2.844M2.336 16.25h3.786M3.278 13h3.787"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 1.5,
                d: "M6.368 9.198a9.049 9.049 0 0 1 3.218-2.795 9.002 9.002 0 0 1 10.498 1.625 9.002 9.002 0 0 1 2.632 6.37c0 2.389-.96 4.68-2.633 6.37-1.674 1.69-3.981 2.633-6.37 2.633a8.854 8.854 0 0 1-4.127-1.008 9.027 9.027 0 0 1-3.218-2.795"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/assets/customIcon/sidewidget-icon/IconAlert.tsx


function IconAlert() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 26,
        height: 26,
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeWidth: 1.5,
                d: "M13 22.75a8.856 8.856 0 1 0 0-17.712 8.856 8.856 0 0 0 0 17.712ZM2.356 6.793l3.56-3.543M23.643 6.793 20.084 3.25"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 1.5,
                d: "M13 9.75v4.875l1.625 1.625"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/assets/customIcon/sidewidget-icon/IconHotlist.tsx


function IconHotlist() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 26,
        height: 26,
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#a)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "none",
                        d: "M0 0h26v26H0z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                        stroke: "currentColor",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: 1.5,
                        clipPath: "url(#b)",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M21.753 15.223c0 4.74-3.92 8.598-8.753 8.598-4.832 0-8.753-3.843-8.753-8.598 0-5.434 5.203-8.182 7.117-12.427.324-.71 1.281-.834 1.744-.216 1.25 1.605 2.949 4.43 2.563 7.518-.108.895.849 1.497 1.59.988.37-.263.772-.603 1.158-1.066.401-.478 1.173-.478 1.559.031a8.5 8.5 0 0 1 1.76 5.172h.015Z"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M10.653 12.017c-5.666 5.548 2.438 8.028 1.341 11.651 3.042.36 6.994-2.435 4.802-5.472-2.193-3.037-3.704-.827-6.143-6.179Z"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "a",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "none",
                            d: "M0 0h26v26H0z"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "b",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "none",
                            d: "M.65.65h24.7v24.7H.65z"
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/assets/customIcon/sidewidget-icon/IconValuation.tsx


function IconValuation() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 26,
        height: 26,
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.5,
            d: "M12.992 22.29 2.162 9.91l5.1-6.2h11.48l5.1 6.18-10.83 12.38-.02.02ZM23.5 9.912H2.143M13.014 22.27 7.264 3.71M13.014 22.27l5.75-18.56"
        })
    });
};

;// CONCATENATED MODULE: ./src/assets/customIcon/sidewidget-icon/IconBandar.tsx


function IconBandar() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 26,
        height: 26,
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "none",
                d: "M0 0h26v26H0z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 1.5,
                d: "M3.623 11.69h18.703M18.5 22.633c.757 0 1.497-.233 2.126-.671a3.953 3.953 0 0 0 1.409-1.788c.29-.728.365-1.53.217-2.302a4.038 4.038 0 0 0-1.046-2.04 3.78 3.78 0 0 0-1.959-1.09 3.684 3.684 0 0 0-2.21.226 3.864 3.864 0 0 0-1.717 1.467 4.104 4.104 0 0 0-.644 2.214c-.001.523.097 1.042.29 1.526.191.484.473.923.828 1.293.355.37.777.664 1.242.864.464.2.962.302 1.465.301v0ZM7.448 22.633c.757 0 1.496-.233 2.125-.671a3.954 3.954 0 0 0 1.409-1.788 4.14 4.14 0 0 0 .218-2.302 4.038 4.038 0 0 0-1.047-2.04 3.78 3.78 0 0 0-1.959-1.09 3.684 3.684 0 0 0-2.21.226 3.864 3.864 0 0 0-1.716 1.467 4.104 4.104 0 0 0-.645 2.214 4.07 4.07 0 0 0 1.12 2.817 3.75 3.75 0 0 0 2.705 1.167ZM11.273 18.648h3.404M18.965 4.805a1.511 1.511 0 0 0-.506-.843 1.405 1.405 0 0 0-.9-.329H8.418c-.327 0-.645.116-.9.33-.256.212-.434.51-.506.842L5.535 11.69h14.878l-1.448-6.885Z"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/assets/customIcon/sidewidget-icon/IconCalendar.tsx


function IconCalendar() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 26,
        height: 26,
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.5,
            d: "M21.125 4.875H4.875c-.897 0-1.625.728-1.625 1.625v13c0 .898.728 1.625 1.625 1.625h16.25c.898 0 1.625-.727 1.625-1.625v-13c0-.897-.727-1.625-1.625-1.625ZM3.25 10.563h19.5M8.938 6.5V3.25M17.063 6.5V3.25"
        })
    });
};

;// CONCATENATED MODULE: ./src/assets/customIcon/sidewidget-icon/IconSupport.tsx


function IconSupport() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 26,
        height: 26,
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.5,
            d: "M6.5 13V9.75c0-3.591 2.909-6.5 6.5-6.5s6.5 2.909 6.5 6.5v6.5c0 3.591-2.909 6.5-6.5 6.5M6.5 12.188a1.625 1.625 0 1 0-3.25 0v3.25a1.625 1.625 0 1 0 3.25 0v-3.25ZM19.5 15.438a1.625 1.625 0 1 0 3.25 0v-3.25a1.625 1.625 0 1 0-3.25 0v3.25Z"
        })
    });
};

// EXTERNAL MODULE: ./src/global/MainLayout/slice.js
var MainLayout_slice = __webpack_require__(48153);
// EXTERNAL MODULE: ./src/constants/clevertap.js
var clevertap = __webpack_require__(92124);
// EXTERNAL MODULE: ./src/utils/clevertap.js
var utils_clevertap = __webpack_require__(48028);
// EXTERNAL MODULE: ./src/global/MainLayout/SideWidget/styled.ts
var styled = __webpack_require__(73164);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./src/global/MainLayout/SideWidget/constants.ts
var SideWidget_constants = __webpack_require__(32457);
;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/utils.ts


var generateSidewidget = function() {
    var country = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "ID";
    if (country === "MY") {
        return SideWidget_constants/* baseMenu */.V3;
    }
    return (0,_to_consumable_array/* default */.Z)(SideWidget_constants/* baseMenu */.V3).concat((0,_to_consumable_array/* default */.Z)(SideWidget_constants/* indonesiaMenu */.OP));
};

// EXTERNAL MODULE: ./src/global/MainLayout/SideWidget/Watchlist/Orderbook/slice.ts
var Orderbook_slice = __webpack_require__(18388);
// EXTERNAL MODULE: ./src/global/MainLayout/SideWidget/Valuation/slice.ts
var Valuation_slice = __webpack_require__(9139);
// EXTERNAL MODULE: ./src/global/MainLayout/SideWidget/Valuation/constants.ts
var Valuation_constants = __webpack_require__(36296);
// EXTERNAL MODULE: ./src/global/MainLayout/SideWidget/BandarDetector/styled.ts
var BandarDetector_styled = __webpack_require__(63914);
// EXTERNAL MODULE: ./src/global/MainLayout/SideWidget/BandarDetector/constants.tsx
var BandarDetector_constants = __webpack_require__(13180);
;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/index.tsx































var Watchlist = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(80822), __webpack_require__.e(91727), __webpack_require__.e(28287), __webpack_require__.e(7957)]).then(__webpack_require__.bind(__webpack_require__, 39458));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(39458)
            ];
        }
    },
    ssr: false
});
var PriceAlert = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(42298), __webpack_require__.e(33082), __webpack_require__.e(74673), __webpack_require__.e(24826), __webpack_require__.e(82676)]).then(__webpack_require__.bind(__webpack_require__, 41210));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(41210)
            ];
        }
    },
    ssr: false
});
var RunningTrade = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(33082), __webpack_require__.e(80822), __webpack_require__.e(1013), __webpack_require__.e(74673), __webpack_require__.e(61442), __webpack_require__.e(88115), __webpack_require__.e(66147)]).then(__webpack_require__.bind(__webpack_require__, 46880));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(46880)
            ];
        }
    },
    ssr: false
});
var Movers = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(80822), __webpack_require__.e(14830)]).then(__webpack_require__.bind(__webpack_require__, 14830));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(14830)
            ];
        }
    },
    ssr: false
});
var Valuation = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(54392), __webpack_require__.e(74673), __webpack_require__.e(24826), __webpack_require__.e(84140)]).then(__webpack_require__.bind(__webpack_require__, 10194));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(10194)
            ];
        }
    },
    ssr: false
});
var BandarDetector = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(74673), __webpack_require__.e(11813)]).then(__webpack_require__.bind(__webpack_require__, 97773));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(97773)
            ];
        }
    },
    ssr: false
});
var Calendar = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(97751), __webpack_require__.e(74673), __webpack_require__.e(43954)]).then(__webpack_require__.bind(__webpack_require__, 89876));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(89876)
            ];
        }
    },
    ssr: false
});
var PRICE_ALERT_KEY = "price-alert";
function SideWidget() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,es/* useSelector */.v9)(MainLayout_slice/* selectors */.wl), current = ref.current, isSideWidgetOpen = ref.isSideWidgetOpen, isMarketOpen = ref.isMarketOpen, bandarDetectorActiveKey = ref.bandarDetectorActiveKey;
    var ref1 = (0,es/* useSelector */.v9)(profile/* selectors */.wl), country = ref1.data.country;
    var isShowSearchCompanyModal = (0,useSearchCompanyModalStore/* default */.Z)(function(s) {
        return s.visible;
    });
    var alert = (0,es/* useSelector */.v9)(slice/* alertWsSelector */.m5);
    var ref2 = useWidget(current), isPro = ref2.isPro, isAddonPro = ref2.isAddonPro, addCounter = ref2.addCounter;
    var ref3 = (0,react.useState)(false), isModalBrokerSummaryOpen = ref3[0], setIsModalBrokerSummaryOpen = ref3[1];
    var clearPriceAlert = function() {
        dispatch(slice/* default.actions.clearAlert */.ZP.actions.clearAlert());
        localStorage.removeItem(PRICE_ALERT_KEY);
    };
    (0,react.useEffect)(function() {
        if (!isSideWidgetOpen && current !== SideWidget_constants/* SIDE_MENU_KEY.ALL_WATCHLIST */.t2.ALL_WATCHLIST) {
            dispatch(Orderbook_slice/* default.actions.setSymbol */.ZP.actions.setSymbol({
                symbol: "IHSG"
            }));
        }
        if (!isSideWidgetOpen) {
            dispatch(// @ts-ignore
            Valuation_slice/* default.actions.setCurrentScreenerData */.ZP.actions.setCurrentScreenerData({
                page: Valuation_constants/* INITIAL_PAGE */.qe,
                presetId: Valuation_constants/* KENNETH_FISHER_PRICE_TO_SALES_ID */.rz,
                isDataLoaded: false,
                type: ""
            }));
        }
    }, [
        isSideWidgetOpen
    ]);
    // hide sidewidget while search company modal is showing
    if (isShowSearchCompanyModal) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
    var renderIcon = function(logo) {
        switch(logo){
            case "icon-widget_watchlist":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWatchlist, {});
            case "icon-widget_alert":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconAlert, {});
            case "icon-widget_runningtrade":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconRunningTrade, {});
            case "icon-widget_hotlist":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconHotlist, {});
            case "icon-widget_valuation":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconValuation, {});
            case "icon-widget_bandar":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconBandar, {});
            case "icon-widget_calendar":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconCalendar, {});
            default:
                return null;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* WidgetContainer */.Hl, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* WidgetWrapper */.wv, {
                isOpen: isSideWidgetOpen,
                isMarketOpen: isMarketOpen,
                children: [
                    current === SideWidget_constants/* SIDE_MENU_KEY.ALL_WATCHLIST */.t2.ALL_WATCHLIST && /*#__PURE__*/ (0,jsx_runtime.jsx)(Watchlist, {}),
                    current === SideWidget_constants/* SIDE_MENU_KEY.PRICE_ALERT */.t2.PRICE_ALERT && /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceAlert, {
                        isPro: isPro
                    }),
                    current === SideWidget_constants/* SIDE_MENU_KEY.RUNNING_TRADE */.t2.RUNNING_TRADE && /*#__PURE__*/ (0,jsx_runtime.jsx)(RunningTrade, {
                        isPro: isPro
                    }),
                    current === SideWidget_constants/* SIDE_MENU_KEY.MOVERS */.t2.MOVERS && /*#__PURE__*/ (0,jsx_runtime.jsx)(Movers, {}),
                    current === SideWidget_constants/* SIDE_MENU_KEY.VALUATION */.t2.VALUATION && /*#__PURE__*/ (0,jsx_runtime.jsx)(Valuation, {
                        isPro: isPro,
                        isProScreener: isAddonPro
                    }),
                    current === SideWidget_constants/* SIDE_MENU_KEY.BANDAR_DETECTOR */.t2.BANDAR_DETECTOR && /*#__PURE__*/ (0,jsx_runtime.jsx)(BandarDetector, {
                        isPro: isPro,
                        activeKey: bandarDetectorActiveKey
                    }),
                    current === SideWidget_constants/* SIDE_MENU_KEY.CALENDAR */.t2.CALENDAR && /*#__PURE__*/ (0,jsx_runtime.jsx)(Calendar, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* Container */.W2, {
                children: [
                    generateSidewidget(country).map(function(param) {
                        var key = param.key, icon = param.icon, text = param.text, eventName = param.eventName;
                        var isPriceAlert = key === SideWidget_constants/* SIDE_MENU_KEY.PRICE_ALERT */.t2.PRICE_ALERT && !!(alert === null || alert === void 0 ? void 0 : alert.msg);
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                            placement: "left",
                            title: text,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ButtonWidget */.bW, {
                                active: current === key,
                                onClick: function() {
                                    if (eventName && current !== key) {
                                        (0,utils_clevertap/* clevertapEvent */.Lq)(clevertap/* CLEVERTAP_EVENT_NAME.SIDE_MENU */.dR.SIDE_MENU, {
                                            Action: eventName
                                        });
                                        addCounter(key);
                                    }
                                    if (isPriceAlert) {
                                        clearPriceAlert();
                                    }
                                    // @ts-ignore
                                    dispatch(MainLayout_slice/* default.actions.setActiveWidget */.ZP.actions.setActiveWidget({
                                        key: key
                                    }));
                                },
                                "data-cy": "right-menu-".concat(eventName),
                                $shouldRenderAfter: isPriceAlert,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        color: "inherit",
                                        width: 26,
                                        height: 26
                                    },
                                    children: renderIcon(icon)
                                })
                            })
                        }, "watchlist-".concat(key));
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                        placement: "left",
                        title: "Support",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* ButtonWidget */.bW, {
                            "data-cy": "right-menu-support",
                            onClick: crisp/* handleClickSupport */.lA,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "intercom-unread-count"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconSupport, {})
                            ]
                        })
                    }, "support"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: current === SideWidget_constants/* SIDE_MENU_KEY.BANDAR_DETECTOR */.t2.BANDAR_DETECTOR && bandarDetectorActiveKey === BandarDetector_constants/* BANDAR_DETECTOR_MENU_KEY.TOP_STOCKS */.lA.TOP_STOCKS,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BandarDetector_styled/* ButtonOpenModal */.Wb, {
                            onClick: function() {
                                return setIsModalBrokerSummaryOpen(true);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                src: "/images/expand.svg",
                                alt: "expand"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BandarDetector_styled/* ModalWrapper */.AB, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BandarDetector_styled/* ModalBrokerSummary */.O9, {
                            className: "modal-".concat(bandarDetectorActiveKey.toLowerCase()),
                            visible: isModalBrokerSummaryOpen,
                            onCancel: function() {
                                return setIsModalBrokerSummaryOpen(false);
                            },
                            bodyStyle: {
                                padding: "0 20px",
                                borderRadius: "4px"
                            },
                            title: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    height: 41,
                                    display: "flex",
                                    alignItems: "center",
                                    paddingLeft: 16
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    style: {
                                        fontSize: 20,
                                        fontWeight: 700
                                    },
                                    children: "Top Stock"
                                })
                            }),
                            width: "940px",
                            footer: null,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BandarDetector, {
                                isPro: isPro,
                                activeKey: bandarDetectorActiveKey,
                                inModal: true
                            })
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var MainLayout_SideWidget = (SideWidget);


/***/ }),

/***/ 73164:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gi": function() { return /* binding */ SymbolLinkWrapper; },
/* harmony export */   "Hl": function() { return /* binding */ WidgetContainer; },
/* harmony export */   "W2": function() { return /* binding */ Container; },
/* harmony export */   "bW": function() { return /* binding */ ButtonWidget; },
/* harmony export */   "hb": function() { return /* binding */ ButtonTransparent; },
/* harmony export */   "wv": function() { return /* binding */ WidgetWrapper; },
/* harmony export */   "xw": function() { return /* binding */ HumbergerButton; }
/* harmony export */ });
/* unused harmony export Box */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var re_resizable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46312);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20539);
/* harmony import */ var _deprecated_ui_widget_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89999);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22147);
/* harmony import */ var _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74575);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-left: 1px solid ",
        ";\n  border-collapse: collapse;\n  box-sizing: border-box;\n  height: 100%;\n  width: 48px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: ",
        ";\n  display: none;\n  z-index: 999;\n  gap: 0;\n  @media ",
        " {\n    height: 100vh;\n    display: flex;\n    position: fixed;\n    top: 0;\n    right: 0;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    height: 100%;\n    border: ",
        ";\n    border-right: none;\n    overflow-y: hidden;\n    width: ",
        ";\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: ",
        ";\n  z-index: 99;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: none;\n  background: none;\n  cursor: pointer;\n  margin: 0;\n  padding: 0;\n\n  &:hover,\n  &:focus {\n    background: none;\n    border: none;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      background: ",
        ";\n      border-left: 1px solid ",
        ";\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      color: ",
        ";\n\n      .icon-widget_runningtrade::before {\n        color: ",
        ";\n      }\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      &:after {\n        content: '';\n        display: block;\n        height: 5px;\n        width: 5px;\n        background: ",
        ";\n        position: absolute;\n        top: 21px;\n        right: 8px;\n        border-radius: 50%;\n      }\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      color: ",
        ";\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: #fff;\n  color: #969696;\n  border: none;\n  border-bottom: 1px solid #dadada;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 66px;\n  position: relative;\n  width: 48px;\n\n  &:hover {\n    color: ",
        ";\n  }\n\n  ",
        "\n\n  ",
        "\n\n  .icon-menu_calendar {\n    color: #6b6b6b;\n    ",
        "\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: inherit;\n\n  &:hover {\n    color: inherit;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}







var Container = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    direction: "column"
}).withConfig({
    componentId: "sc-73a3804d-0"
})(_templateObject(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].gainsboro */ .Z.gainsboro);
var WidgetContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-73a3804d-1"
})(_templateObject1(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].light */ .Z.light, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_6__/* ["default"].tablet */ .Z.tablet);
var WidgetWrapper = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-73a3804d-2"
})(function(param) {
    var isOpen = param.isOpen, isMarketOpen = param.isMarketOpen;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject2(), isOpen ? "1px solid #DADADA" : 0, isOpen ? isMarketOpen ? "331px" : "390px" : 0);
});
var Box = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(re_resizable__WEBPACK_IMPORTED_MODULE_1__/* .Resizable */ .e).attrs({
    enable: {
        top: false,
        right: false,
        bottom: true,
        left: false,
        topRight: false,
        bottomRight: false,
        bottomLeft: false,
        topLeft: false
    }
}).withConfig({
    componentId: "sc-73a3804d-3"
})(_templateObject3(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].light */ .Z.light);
var ButtonTransparent = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-73a3804d-4"
})(_templateObject4());
var HumbergerButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(_deprecated_ui_widget_Button__WEBPACK_IMPORTED_MODULE_4__/* .HumbergerButton */ .x).withConfig({
    componentId: "sc-73a3804d-5"
})(_templateObject6(), function(param) {
    var active = param.active;
    return active && (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject5(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].light */ .Z.light, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].gainsboro */ .Z.gainsboro);
});
var ButtonWidget = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-73a3804d-6"
})(_templateObject10(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].primary */ .Z.primary, function(param) {
    var active = param.active;
    return active && (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject7(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].primary */ .Z.primary, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].primary */ .Z.primary);
}, function(param) {
    var $shouldRenderAfter = param.$shouldRenderAfter;
    return $shouldRenderAfter && (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject8(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].primary */ .Z.primary);
}, function(param) {
    var active = param.active;
    return active && (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject9(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].primary */ .Z.primary);
});
var SymbolLinkWrapper = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    componentId: "sc-73a3804d-7"
})(_templateObject11());



/***/ }),

/***/ 5612:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14671);

var useSearchCompanyModalStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(function(set) {
    return {
        visible: false,
        showModal: function() {
            set({
                visible: true
            });
        },
        closeModal: function() {
            set({
                visible: false
            });
        }
    };
});
/* harmony default export */ __webpack_exports__["Z"] = (useSearchCompanyModalStore);


/***/ }),

/***/ 70735:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var config_requestExodus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68425);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37213);


var screenerURL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_EXODUS_URL */ .q7, "/screener");
var request = (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
var getScreenerCustom = function() {
    return request.get("".concat(screenerURL, "/templates"));
};
var getScreenerMetrics = function() {
    return request.get("".concat(screenerURL, "/preset"));
};
var getLoadPresetScreener = function(id, type) {
    var queryString = type ? "?type=".concat(type) : "";
    return request.get("".concat(screenerURL, "/templates/").concat(id).concat(queryString));
};
var getScreenerUniverse = function() {
    return request.get("".concat(screenerURL, "/universe"));
};
var postScreenerListResult = function(data) {
    return request.post("".concat(screenerURL, "/templates"), data);
};
var getScreenerFavorites = function() {
    return request.get("".concat(screenerURL, "/favorites"));
};
var addScreenerFavorite = function(screenerid, type) {
    return request.post("".concat(screenerURL, "/favorites"), {
        screenerid: screenerid,
        type: type
    });
};
var removeScreenerFavorite = function(screenerid, type) {
    return request.delete("".concat(screenerURL, "/favorites/").concat(screenerid, "?type=").concat(type));
};
var getScreenerFinancial = function() {
    return request.get("".concat(screenerURL, "/metric"));
};
var removeScreenerCustom = function(screenerID) {
    return request.delete("".concat(screenerURL, "/templates/").concat(screenerID));
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    getScreenerCustom: getScreenerCustom,
    getScreenerMetrics: getScreenerMetrics,
    getLoadPresetScreener: getLoadPresetScreener,
    getScreenerUniverse: getScreenerUniverse,
    postScreenerListResult: postScreenerListResult,
    getScreenerFavorites: getScreenerFavorites,
    addScreenerFavorite: addScreenerFavorite,
    removeScreenerFavorite: removeScreenerFavorite,
    getScreenerFinancial: getScreenerFinancial,
    removeScreenerCustom: removeScreenerCustom
});


/***/ }),

/***/ 17065:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var config_requestExodus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68425);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37213);
/* eslint-disable import/named */ 



var valuationURL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_EXODUS_URL */ .q7, "/valuation");
var request = (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
var getValuationTemplate = function() {
    return request.get("".concat(valuationURL, "/all/templates"));
};
var getValuationMetrics = function() {
    return request.get("".concat(valuationURL, "/metrics/lists"));
};
var postDeleteValuationTemplate = function(valuationId) {
    return request.delete("".concat(valuationURL, "/").concat(valuationId));
};
var postValuationResult = function(_param) {
    var symbol = _param.symbol, data = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "symbol"
    ]);
    return request.post("".concat(valuationURL, "/company/").concat(symbol), data);
};
var postValuationTemplateSave = function(templateId, data) {
    return request.put("".concat(valuationURL, "/").concat(templateId), data);
};
var postValuationTemplateAdd = function(data) {
    return request.post("".concat(valuationURL), data);
};
var getValuationTemplateLoad = function(templateId) {
    return request.get("".concat(valuationURL, "/").concat(templateId));
};
var getValuationMetricsDefault = function(_param) {
    var symbol = _param.symbol, data = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "symbol"
    ]);
    return request.get("".concat(valuationURL, "/company/").concat(symbol, "/metrics"), {
        params: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, data)
    });
};
var getValuationMetricPerID = function(symbol, metricID) {
    return request.get("".concat(valuationURL, "/company/").concat(symbol, "/metrics"), {
        params: {
            metric: metricID
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    getValuationTemplate: getValuationTemplate,
    getValuationMetrics: getValuationMetrics,
    postDeleteValuationTemplate: postDeleteValuationTemplate,
    postValuationResult: postValuationResult,
    postValuationTemplateSave: postValuationTemplateSave,
    postValuationTemplateAdd: postValuationTemplateAdd,
    getValuationTemplateLoad: getValuationTemplateLoad,
    getValuationMetricsDefault: getValuationMetricsDefault,
    getValuationMetricPerID: getValuationMetricPerID
});


/***/ })

}]);